import { post } from '../../shared/services/http.service';

const baseUrl = (applicationId: string) => `/applications/${applicationId}/outbound-messages`;

export const sendMessage = async (request: { message: string }, applicationId: string, userProfileId: string) => {
    return post(`${baseUrl(applicationId)}/viber/${userProfileId}`, { data: request });
}
